import { Map, Record } from "immutable";

import StudentAssignment from "./StudentAssignment";
import AssignmentMeta from "./StudentAssignmentsMetaState";

export type StudentAssignmentsStateType = {
  assignments: Map<string, StudentAssignment>;
  meta: AssignmentMeta;
};

const defaultStudentAssignmentsState: StudentAssignmentsStateType = {
  assignments: Map<string, StudentAssignment>(),
  meta: new AssignmentMeta()
};

export default class StudentAssignmentsState extends Record(
  defaultStudentAssignmentsState
) {}
